<template>
    <div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="">
        <div class="auth-box">
            <div>
                <div class="logo">
                    <span class="db"><img alt="logo" src="../../assets/images/logo/Borlaug_CX_High.png"/></span>
                    <p></p>
                    <h5 class="font-medium m-b-20">Welcome back!</h5>
                    <p></p>
                </div>
                <!-- Form -->
                <div class="row">
                    <div class="col-12">
                        <form @submit.prevent="login" class="form-horizontal m-t-20" id="loginform">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="ti-user"></i></span>
                                </div>
                                <input :class="{'is-invalid': submitted && errors.has('email')}" aria-describedby="Email"
                                       aria-label="Email"
                                       class="form-control form-control-lg"
                                       data-vv-as="Email"
                                       id="email"
                                       name="email"
                                       placeholder="Email"
                                       type="text"
                                       v-model="credentials.email"
                                       v-validate="'required|email'">
                                <div class="invalid-feedback" v-if="submitted && errors.has('email')">{{
                                    errors.first('email') }}
                                </div>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="ti-pencil"></i></span>
                                </div>
                                <input :class="{'is-invalid': submitted && errors.has('password')}" aria-describedby="Password"
                                       aria-label="Password"
                                       class="form-control form-control-lg"
                                       data-vv-as="Password"
                                       id="password"
                                       name="password"
                                       placeholder="Password"
                                       type="password"
                                       v-model="credentials.password"
                                       v-validate="'required'">
                                <div class="invalid-feedback" v-if="submitted && errors.has('password')">{{
                                    errors.first('password') }}
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <div class="form-check">
                                        <input class="form-check-input" id="customCheck1" type="checkbox">
                                        <label class="form-check-label" for="customCheck1">Remember me</label>
                                        <a class="text-dark float-right" href="javascript:void(0)" id="to-recover"><i
                                                class="fa fa-lock m-r-5"></i> Forgot pwd?</a>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group text-center">
                                <div class="col-xs-12 p-b-20">
                                    <button class="btn btn-block btn-lg btn-acrecx" type="submit">Log In</button>
                                </div>
                            </div>
                            <div class="form-group m-b-0 m-t-10">
                                <div class="col-sm-12 text-center">
                                    Don't have an account?
                                    <router-link :to="{ name: 'signup'}" class="text-info m-l-5"><b>Sign up</b>
                                    </router-link>
                                    to be invited.
                                </div>
                            </div>
                            <hr>
                            <div class="form-group m-b-0 m-t-10">
                                <div class="col-sm-12 text-center text-muted">
                                    Release {{this.$parent.version}}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div id="recoverform">
                <div class="logo">
                    <span class="db"><img alt="logo" src="../../assets/images/logo/logo-icon.png"/></span>
                    <h5 class="font-medium m-b-20">Recover Password</h5>
                    <span>Enter your Email and instructions will be sent to you!</span>
                </div>
                <div class="row m-t-20">
                    <!-- Form -->
                    <form action="index.html" class="col-12">
                        <!-- email -->
                        <div class="form-group row">
                            <div class="col-12">
                                <input class="form-control form-control-lg"
                                       data-vv-as="Email"
                                       placeholder="Email"
                                       required=""
                                       type="email">
                            </div>
                        </div>
                        <!-- pwd -->
                        <div class="row m-t-20">
                            <div class="col-12">
                                <button class="btn btn-block btn-lg btn-danger" name="action" type="submit">Reset
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                submitted: false,
                loading: false,
                credentials: {
                    email: '',
                    password: ''
                },
                loggingIn: false,
                error: ''
            }
        },
        mounted() {
            this.init();
            this.$parent.release();
        },
        methods: {
            init() {
                $('[data-toggle="tooltip"]').tooltip();
                $(".preloader").fadeOut();

                $('#to-recover').on("click", function () {
                    $("#loginform").slideUp();
                    $("#recoverform").fadeIn();
                });
            },
            checkCurrentLogin() {
                if (this.currentUser) {
                    this.$router.replace(this.$route.query.redirect || '/')
                }
            },
            login() {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        if (valid) {
                            self.loading = true;
                            this.$http.post('/login', {
                                email: this.credentials.email,
                                password: this.credentials.password
                            })
                                .then(reply => this.loginSuccessful(reply))
                                .catch(err => this.loginFailed(err))
                        }
                    });
            },
            async loginSuccessful(reply) {
                this.loading = false;
                if (!reply.data.token) {
                    this.loginFailed();
                    return
                }

                await this.storeBwsToken();
                this.$store.commit("LOGIN", reply.data);
                await this.$router.replace(this.$route.query.redirect || '/');
            },
            async storeBwsToken() {
                try {
                    let reply = await this.$accounts.post(`/accounts/users/login`, this.credentials);
                    this.$store.commit("BWS_LOGIN", reply.data);
                } catch (e) {

                }
            },
            loginFailed(err) {
                this.loading = false;

                let data = err.response.data;
                if (data.status === 404) {
                    this.$swal({
                        type: 'error',
                        title: 'Profile Not Found',
                        text: 'Your email was not found. Please make sure your email was typed correctly.',
                        timer: 5000
                    });
                } else if (data.status === 412) {
                    console.log(data)
                    this.$swal({
                        type: 'error',
                        title: `${data.name}`,
                        text: `${data.reason}`,
                        timer: 5000
                    });
                } else {
                    this.$swal({
                        type: 'error',
                        title: 'Authentication Error',
                        text: data.description || data.detail,
                        timer: 5000
                    });
                }

                this.error = 'Login failed!';
                this.$store.dispatch('logout');
                delete localStorage.token;
            }
        }
    }
</script>

<style scoped>
    .auth-wrapper {
        background: linear-gradient(0deg, rgba(54, 64, 78, 0.75), rgba(54, 64, 78, 0.75)), url(../../assets/images/big/farmer.jpg);
        background-size: cover;
    }
</style>
